<template>
  <v-autocomplete
    v-model="selectedItem"
    :items="items"
    :search-input.sync="search"
    :loading="isLoading"
    :item-text="itemText"
    :item-value="itemValue"
    :return-object="returnObject"
    @change="onChange"
    v-bind="$attrs"
  >
    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>No data found.</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <template v-slot:selection="data">
      <v-chip>{{ data.item[itemText] }}</v-chip>
    </template>
    <template v-slot:item="data">
      <v-list-item-content>
        <v-list-item-title>{{ data.item[itemText] }}</v-list-item-title>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
let timeout; // Declare timeout variable outside Vue component

export default {
  props: {
    delay: {
      type: Number,
      default: 300
    },
    itemText: {
      type: String,
      default: "name"
    },
    itemValue: {
      type: String,
      default: "id"
    },
    returnObject: {
      type: Boolean,
      default: true
    },
    fetchData: {
      type: Function,
      required: true
    },
  },
  data() {
    return {
      selectedItem: null,
      search: null,
      items: [],
      isLoading: false,
    };
  },
  watch: {
    search(val) {
      if (val && val.length > 2) {
        // Clear the previous timeout if it exists
        if (timeout) {
          clearTimeout(timeout);
        }

        // Set a new timeout
        timeout = setTimeout(() => {
          this.querySelections(val);
        }, this.delay); // use prop delay
      }
    },
  },
  methods: {
    async querySelections(v) {
      this.isLoading = true;
      try {
        this.items = await this.fetchData(v);
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    onChange() {
      this.$emit("input", this.selectedItem);
    },
  },
};
</script>
